export function validatorName(name) {
  const regSpecialChar = /[~`'\\\\/|#¥￥$%^&]/;
  return !regSpecialChar.test(name);
}

export function regNumber(number) {
  const regNumber = /^[0-9]*$/;
  return regNumber.test(number);
}

export function regTel(number) {
  const regTel = /^[1-9][0-9]*$/;
  return regTel.test(number);
}

export function regCellPhone(number) {
  const regPhone = /^1[0-9]{10}$/;
  return regPhone.test(number);
}

export function splicePhone(countryCode, areaCode, phone, ext) {
  return (
    countryCode + "-" + areaCode + "-" + phone + ("" !== ext ? "-" + ext : "")
  );
}

export function spliceCellPhone(countryCode, phone) {
  return countryCode + "--" + phone;
}

export function isChinaCellPhone(countryCode, phone) {
  if ((countryCode !== "" && countryCode !== "86") || regCellPhone(phone)) {
    return true;
  }
  return false;
}

export function spliceTelNumberKey(countryCode, areaCode, phone, ext = "") {
  // 如果countryCode !== 86 或者 phone是手机号
  let telNumberKey = "";
  if (isChinaCellPhone(countryCode, phone)) {
    telNumberKey = countryCode + "--" + phone;
  } else {
    telNumberKey =
      countryCode +
      "-" +
      areaCode +
      "-" +
      phone +
      ("" !== ext ? "-" + ext : "");
  }
  return telNumberKey;
}

export function buildAcmPhone(countryCode, areaCode, phone, ext) {
  if (countryCode) {
    if (typeof countryCode === "number") {
      countryCode = countryCode.toString();
    }
    if ("+" === countryCode[0]) {
      countryCode = countryCode.substr(1);
    }
    if ("00" === countryCode.substr(0, 2)) {
      countryCode = countryCode.substr(1);
    }
    countryCode = `(${countryCode})`;
  } else {
    throw new Error("empty countryCode");
  }

  if (areaCode) {
    if (typeof areaCode === "number") {
      areaCode = areaCode.toString();
    }
    if ("0" === areaCode[0]) {
      areaCode = areaCode.substr(1);
    }
  }

  if (phone) {
    if (typeof phone === "number") {
      phone = phone.toString();
    }
    if ("0" === phone[0]) {
      phone = phone.substr(1);
    }
    if (ext) {
      phone = phone + "-" + ext;
    }
  } else {
    throw new Error("empty phone");
  }

  return `${countryCode}${areaCode}${phone}`;
}
